import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=3f07369c&scoped=true&"
import script from "./Dialog.vue?vue&type=script&lang=ts&"
export * from "./Dialog.vue?vue&type=script&lang=ts&"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=3f07369c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07369c",
  null
  
)

export default component.exports